<template>
  <RadioGroup
    name="userPasswordOptions"
    :options="options"
    :showValidationMessage="false"
    :value="String(value)"
    @input="$emit('input', $event === 'true')"
  />
</template>

<script>
import { RadioGroup } from '@jumpcloud/ui-components';

export default {
  name: 'UserPasswordOptions',

  components: {
    RadioGroup,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    options: [
      {
        label: 'Force user to set their own password at first login',
        value: 'true',
      },
      {
        label: 'Allow user to keep admin-created password',
        value: 'false',
      },
    ],
  }),
};
</script>
